/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-07-06 16:23:08
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-08-20 14:41:33
 */
import * as types from './mutation-types';
import { getPermissionInfo, listSimpleDictDatas } from '@/api/permission';
import { commissionGetCurrentRule } from '@/api/common';
/**
 * @description: 动态设置菜单栏，从后端获取权限菜单值
 * @param {*}
 * @return {*}
 * @acthor: Li Yong
 * @Date: 2021-10-26 19:40:37
 */
import { menuList } from '@/api/user';
import { actCategoryList } from '@/api/shopManage';
import { PLATFORM_DY, PLATFORM_KS, PLATFORM_SP, DATAVIEW_NO_TAG } from '@/utils/dataMap';
import localRouter from '@/menus/router';
import store from '@/store';
import axios from 'axios';

export const setActCategoryList = ({ commit }) => {
	return new Promise(async resolve => {
		const { data: { list: dyList = [] } = {} } = await actCategoryList({ platform_id: PLATFORM_DY.value });
		commit(types.DY_CATEGORY, dyList);
		const { data: { list: ksList = [] } = {} } = await actCategoryList({ platform_id: PLATFORM_KS.value });
		commit(types.KS_CATEGORY, ksList);
		// 视频号不需要行业大类  目前有两种类目接口 只有快手会返回不一样的数据
		// 其实完全可以不用视频号的全局数据 不过为了统一性还是加载了数据， 后端说这种接口没有压力（不然组件呢会出现 其余平台不请求接口 视频需要请求接口）
		const { data: { list: spList = [] } = {} } = await actCategoryList({ platform_id: PLATFORM_SP.value });
		commit(types.SP_CATEGORY, spList);
		resolve();
	});
};

/**
 * @description: 设置可切换数据视角列表
 * @param {*} userTypes 当前用户的标签列表
 * @return {*}
 * @acthor: Li Yong
 * @Date: 2022-12-14 18:20:40
 */
const getChangeDataViewList = userTypes => {
	// 用户标签过滤掉管理员标签，管理员标签不展示
	const usrTagList = userTypes
		.filter(item => ![dataMap.tzRoleType.id, dataMap.cgRoleType.id].includes(item.type))
		.reverse()
		.map(({ type, name }, ind, arr) => ({
			value: dataMap.DATA_VIEW_OBJ[type],
			label: arr.length > 1 ? `${name}视角(本人数据)` : '本人数据',
			icon: `i-view-${dataMap.DATA_VIEW_OBJ[type]}`,
			iconActive: `i-view-active-${dataMap.DATA_VIEW_OBJ[type]}`,
		}));
	// 用于切换的数据视角列表
	const changeDataViewList = store.getters.hasDeptDataScope
		? [
				{
					label: '全部数据',
					value: dataMap.DATAVIEW_ALL_DEPT,
					icon: `i-view-${dataMap.DATAVIEW_ALL_DEPT}`,
					iconActive: `i-view-active-${dataMap.DATAVIEW_ALL_DEPT}`,
				},
				...usrTagList,
		  ]
		: [...usrTagList];
	return changeDataViewList;
};
/**
/**
 * @description: 设置账户权限信息
 * @param {*} commit
 * @return {*}
 * @acthor: Li Yong
 * @Date: 2022-08-26 15:26:42
 */
export const setPermissionInfo = ({ commit }) => {
	return new Promise(async resolve => {
		const data = await getPermissionInfo();
		const {
			tenant: { platformIds = [] } = {},
			user: { userTypes = [] },
		} = data;
		// 设置开通的平台信息
		commit(types.PERMISSION_INFO, data);
		commit(types.TEAM_CONFIG, { platform_list: platformIds }); 
		commit(types.USER_TYPE_LIST, userTypes);
		// 设置视图可切换列表
		const changeDataViewList = getChangeDataViewList(userTypes);
		commit(types.DATA_VIEW_LIST, changeDataViewList);
		let vuex_dataViewId = sessionStorage.getItem('vuex_dataViewId');
		if (!vuex_dataViewId) {
			// 如果没设置过设置当前的视角取第一个
			let dataViewId = '';
			if (changeDataViewList.length) {
				dataViewId = changeDataViewList[0]?.value;
			} else {
				dataViewId = DATAVIEW_NO_TAG;
			}
			commit(types.DATA_VIEW_ID, dataViewId);
		}
		resolve();
	});
};

//团队有没有设置规则
// export const GetCurrentRule = ({ commit }) => {
// 	return new Promise(async resolve => {
// 		const data = await commissionGetCurrentRule();
// 		commit(types.COMMISSION_RULES, data || {});
// 		resolve();
// 	});
// };

/**
 * @description: 加载字典数据
 * @param {*} commit
 * @return {*}
 * @acthor: Li Yong
 * @Date: 2022-08-31 14:32:52
 */
export const loadDictDatas = ({ commit }) => {
	return new Promise(async resolve => {
		try {
			const { list = [] } = await listSimpleDictDatas();
			// 设置数据
			const dictDataMap = {};
			list?.forEach(dictData => {
				// 获得 dictType 层级
				const enumValueObj = dictDataMap[dictData.dictType];
				if (!enumValueObj) {
					dictDataMap[dictData.dictType] = [];
				}
				// 处理 dictValue 层级
				dictDataMap[dictData.dictType].push({
					value: dictData.value,
					label: dictData.label,
					colorType: dictData.colorType,
					cssClass: dictData.cssClass,
				});
			});
			// 存储到 Store 中
			commit('SET_DICT_DATAS', dictDataMap);
			resolve();
		} catch (error) {
			console.log(error);
		}
	});
};
export const checkVersion = ({ commit, state }) => {
	let latestVersion;
	return new Promise(resolve => {
		// 请求模糊匹配app.开头的文件, 并且禁止缓存
		axios
			.get('/js/app.*?v=' + new Date().getTime(), {
				headers: { 'Cache-Control': 'no-cache' },
				baseURL:
					window.location.origin ||
					window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : ''),
			})
			.then(res => {
				latestVersion = res.headers['last-modified'];
				const currentPageVersion = localStorage.getItem('CURRENT_PAGE_VERSION');
				if (latestVersion !== currentPageVersion) {
					store.commit(types.UPDATE_INFP, { updateInfo: latestVersion !== currentPageVersion, latestVersion });
				}
				resolve({ update: latestVersion !== currentPageVersion, latestVersion });
			})
			.catch(err => {
				console.log('checkVersion err', err);
			})
			.finally(() => {
				localStorage.setItem('CURRENT_PAGE_VERSION', latestVersion);
			});
	});
};
